module.exports = {"retryLogin.modal.content.text":"Eine Bestätigung wurde an Ihre Email-Adresse gesendet. Um die Aktivierung abzuschließen, klicken Sie auf den Bestätigungslink in der Email, kehren Sie zu dieser Seite zurück und versuchen Sie es erneut.","retryLogin.modal.content.action.buttonLabel":"Versuchen Sie es jetzt noch einmal"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/de/components/ModalContent/RetryLogin.json
// module id = 872
// module chunks = 0